//there could be more than one button so loop and add event listener for each

document.addEventListener("DOMContentLoaded", function() {
  const sizeChartBtns = document.querySelectorAll(".sizeChartButton");
  
  // console.log(sizeChartBtns);

  sizeChartBtns.forEach(btn => {

    btn.addEventListener("click", function() {
      const collapsibleBtns = document.querySelectorAll('button.label.collapsible-trigger');
      const chartCollapsibleBtn = [...collapsibleBtns].find(el=>
        el.innerText.includes("SIZE")
      );
      
      if(chartCollapsibleBtn){
      const productId = chartCollapsibleBtn.getAttribute("aria-controls");
      const collapsedDiv = document.getElementById(productId);
      
        chartCollapsibleBtn.classList.add('is-open');
        collapsedDiv.classList.add('is-open');
        collapsedDiv.style.height = "auto";
        chartCollapsibleBtn.scrollIntoView({
          behavior: 'smooth', // Optional: for smooth scrolling animation
          block: 'start'      // Optional: align the top of the element with the top of the viewport
        });
      }
      // console.log("Size Chart button clicked!", chartCollapsibleBtn);
    });
    
  });

});